export enum BillingStepEnum {
    HOME = 'HOME',
    CHOOSE_PLAN = 'CHOOSE_PLAN',
    DOWNGRADE_CONFIRM = 'DOWNGRADE_CONFIRM',
    DOWNGRADE_FINAL = 'DOWNGRADE_FINAL',
    CANCEL_DISPLAY_CONFIRM = 'CANCEL_DISPLAY_CONFIRM',
    CANCEL_DISPLAY_FINAL = 'CANCEL_DISPLAY_FINAL',
    CANCEL_CELLULAR_CONFIRM = 'CANCEL_CELLULAR_CONFIRM',
    CANCEL_CELLULAR_FINAL = 'CANCEL_CELLULAR_FINAL',
    PRO_PAYMENT = 'PRO_PAYMENT',
    STANDARD_PAYMENT = 'STANDARD_PAYMENT',
    CHANGE_DISPLAY_QUANTITY = 'CHANGE_DISPLAY_QUANTITY',
    CHANGE_ANALYTICS_QUANTITY = 'CHANGE_ANALYTICS_QUANTITY',
    FINAL = 'FINAL',
    UPCOMING_DISPLAY_INVOICE = 'UPCOMING_DISPLAY_INVOICE',
    UPCOMING_CELLULAR_INVOICE = 'UPCOMING_CELLULAR_INVOICE',
    UPCOMING_ANALYTICS_INVOICE = 'UPCOMING_ANALYTICS_INVOICE',
};
